module.exports = __webpack_public_path__ + "img/file.b6e6159e.svg";